import React from 'react'
import { InternalTransactionItem } from './InternalTransactionItem'
import { Transaction } from '../../../app/models/generated'
import styles from '../BlocksPage/index.module.sass'
interface TransactionArrayInterface {
    TransactionArray: Array<Transaction>
}

export const InternalTransactionItems = ({
    TransactionArray,
}: TransactionArrayInterface) => {
    return (
        <tbody className={styles.tableBody}>
            {TransactionArray.map((transaction: Transaction) => {
                return (
                    <InternalTransactionItem
                        key={transaction.hash}
                        transaction={transaction}
                    />
                )
            })}
        </tbody>
    )
}
